// Helper function to validate email format
export var isValidEmail = function (email) {
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};
export var getCookie = function (cookieName) {
    var cookies = document.cookie.split(";");
    for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
        var cookie = cookies_1[_i];
        var _a = cookie.trim().split("="), name_1 = _a[0], value = _a[1];
        if (name_1 === cookieName) {
            return decodeURIComponent(value);
        }
    }
    return null;
};
export var isAuthenticated = function () {
    var authStatus = getCookie("isAuthenticated");
    return authStatus === "true";
};
// src/utils/localStorageUtils.ts
/**
 * Save any object to localStorage with JSON serialization
 */
export var saveToLocalStorage = function (key, value) {
    try {
        var json = JSON.stringify(value);
        localStorage.setItem(key, json);
    }
    catch (err) {
        console.error("Error saving ".concat(key, " to localStorage"), err);
    }
};
/**
 * Load object from localStorage (parsed from JSON)
 */
export var loadFromLocalStorage = function (key, fallback) {
    try {
        var stored = localStorage.getItem(key);
        return stored ? JSON.parse(stored) : fallback;
    }
    catch (err) {
        console.error("Error loading ".concat(key, " from localStorage"), err);
        return fallback;
    }
};
/**
 * Remove a specific key from localStorage
 */
export var clearFromLocalStorage = function (key) {
    try {
        localStorage.removeItem(key);
    }
    catch (err) {
        console.error("Error clearing ".concat(key, " from localStorage"), err);
    }
};
export function debounce(func, delay) {
    var timeoutId = null;
    var debouncedFunction = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (timeoutId)
            clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
            func.apply(void 0, args);
        }, delay);
    };
    debouncedFunction.cancel = function () {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    return debouncedFunction;
}
/**
 * Performs a simple deep comparison between two values.
 * Note: This handles basic objects, arrays, and primitives,
 * but does not handle complex types like Maps, Sets, or Date objects.
 */
var simpleDeepEqual = function (a, b) {
    if (a === b)
        return true;
    if (typeof a !== "object" ||
        a === null ||
        typeof b !== "object" ||
        b === null) {
        return a === b;
    }
    // Handle arrays
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length)
            return false;
        for (var i = 0; i < a.length; i++) {
            if (!simpleDeepEqual(a[i], b[i]))
                return false;
        }
        return true;
    }
    // Handle objects
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length)
        return false;
    for (var _i = 0, keysA_1 = keysA; _i < keysA_1.length; _i++) {
        var key = keysA_1[_i];
        if (!keysB.includes(key) || !simpleDeepEqual(a[key], b[key])) {
            return false;
        }
    }
    return true;
};
/**
 * Compares current form values with initial values and returns an object
 * containing only the fields that have been changed.
 */
export var getDirtyFieldsPayload = function (currentValues, initialValues) {
    var dirtyPayload = {};
    for (var key in currentValues) {
        if (currentValues.hasOwnProperty(key)) {
            var currentValue = currentValues[key];
            var initialValue = initialValues[key];
            if (!simpleDeepEqual(currentValue, initialValue)) {
                // If the value has changed, add it to the payload
                dirtyPayload[key] = currentValue;
            }
        }
    }
    return dirtyPayload;
};
